import React from 'react';

import requireAuth from '../components/hocs/requireAuth';
import AdminTemplate from '../layout/AdminTemplate';
import { RenderHistoryPage } from '~features/render-history';

const META_TAGS = {
  title: 'Render History - Prerender.io',
};

const NewRenderHistoryPage = () => {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <RenderHistoryPage />
    </AdminTemplate>
  );
};

export default requireAuth(NewRenderHistoryPage);
